import { api } from '@oneview/api/baseApi';
import { alertReducer, persistStateReducer } from '@orbis-systems/orbis-react-toolkit';
import { AnyAction, combineReducers } from '@reduxjs/toolkit';
import { Reducer } from 'redux';
import { RouterState } from 'redux-first-history';
import { authReducer } from './auth/authReducer';
import { insightsReducer } from './insights/insightsReducer';
import { miscReducer } from './misc/miscReducers';
import { settingReducer } from './settings/settingReducer';
import { tabBarReducer } from './tabBar/tabBarReducer';
import { tradingReducer } from './trading/tradingReducer';

export const createRootReducer = (routerReducer: Reducer<RouterState, AnyAction>) =>
    combineReducers({
        [api.reducerPath]: api.reducer,
        _ortkAlert: alertReducer,
        _ortkPersistState: persistStateReducer,
        router: routerReducer,
        auth: authReducer,
        tabBar: tabBarReducer,
        setting: settingReducer,
        insights: insightsReducer,
        misc: miscReducer,
        trading: tradingReducer,
    });

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;
